import { render } from "./AllSegmentGroups.vue?vue&type=template&id=0b317db0&scoped=true"
import script from "./AllSegmentGroups.vue?vue&type=script&lang=js"
export * from "./AllSegmentGroups.vue?vue&type=script&lang=js"

import "./AllSegmentGroups.vue?vue&type=style&index=0&id=0b317db0&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b317db0"]])

export default __exports__